import { createSlice } from "@reduxjs/toolkit";
const initialVal = { value: null }; /*{
    "id": 0,
    "customerId": 0,
    "userName": "string",
    "displayName": "string",
    "drones": [
        {
            "customerId": 0,
            "name": "string",
            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
        }
    ],
    "lastMissionDate": "2024-11-02T11:27:01.222Z",
    "totalMissionHours": "string",
    "roles": 0
}*/
export const userSlice = createSlice({
    name: "user",
    initialState: initialVal,
    reducers: {
        setUser: (state, action) => {
            state.value = action.payload;
        },
    },
});
export const { setUser } = userSlice.actions;
export default userSlice.reducer;
